/**
 * useSessionMostRecentlyUpdatedModelId
 *
 * Returns the most recently updated model ID reactively from Redux state.
 *
 * Backed by the session RTK Slice.
 *
 * @see src/store/slices/sessionSlice.ts
 */
import { useAppSelector } from '@/store/hooks';
import { selectMostRecentlyUpdatedModelId } from '@/store/slices/sessionSlice';
export const useSessionMostRecentlyUpdatedModelId = () => (useAppSelector(selectMostRecentlyUpdatedModelId));
